module.exports = __webpack_public_path__ + "media/images/ifutur-17088f129f57d3365c5bf0f76baf9c5f.png";